module.exports = __webpack_public_path__ + "static/img/starbucks.e09decd6.jpg";